"use client";
import { jsx as o } from "react/jsx-runtime";
import { memo as e } from "react";
import r from "../components/Icon/SvgIcon.js";
const m = (l) => /* @__PURE__ */ o(
  r,
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ...l,
    children: /* @__PURE__ */ o(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "m21.657 8.274-11.215 11.08a1.15 1.15 0 0 1-1.609.034l-6.482-6.4a1.113 1.113 0 0 1-.035-1.588l1.931-1.906a1.15 1.15 0 0 1 1.61-.034l3.826 3.778 8.47-8.36c.436-.449 1.106-.523 1.552-.086l1.94 1.927c.503.545.439 1.125.012 1.555",
        clipRule: "evenodd"
      }
    )
  }
), n = e(m);
export {
  n as Checkmark,
  n as default
};
